"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolationMethods = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Returns the light value of the closest pixel of the given coordinates.
 */


var closestNeighbourInterpolation = function closestNeighbourInterpolation(xCoord, yCoord, imgBuffer) {
  return imgBuffer.getPixel({
    x: Math.round(xCoord),
    y: Math.round(yCoord)
  });
};
/**
 * Returns the light value of the given coordinates assuming that the light
 * values of the closest pixels vary linearly.
 */


var bilinearInterpolation = function bilinearInterpolation(xCoord, yCoord, imgBuffer) {
  var A = imgBuffer.getPixel({
    x: Math.floor(xCoord),
    y: Math.ceil(yCoord)
  });
  var B = imgBuffer.getPixel({
    x: Math.ceil(xCoord),
    y: Math.ceil(yCoord)
  });
  var C = imgBuffer.getPixel({
    x: Math.floor(xCoord),
    y: Math.floor(yCoord)
  });
  var D = imgBuffer.getPixel({
    x: Math.ceil(xCoord),
    y: Math.floor(yCoord)
  });
  var p = xCoord - Math.floor(xCoord);
  var q = yCoord - Math.floor(yCoord);
  var transform = [];

  for (var i = 0; i < _RgbaImageBuffer.default.NUM_CHANNELS; ++i) {
    transform[i] = C[i] + (D[i] - C[i]) * p + (A[i] - C[i]) * q + (B[i] + C[i] - A[i] - D[i]) * p * q;
  }

  return transform;
};

var interpolationMethods = {
  closestNeighbourInterpolation: closestNeighbourInterpolation,
  bilinearInterpolation: bilinearInterpolation
};
exports.interpolationMethods = interpolationMethods;